<template>
<div>
    <v-form>
        <v-layout justify-space-between column>
            <v-flex xs12 sm12 md12 pa-1>
                <v-card class="white--text">
                    <v-card flat="">
                        <v-card-actions>
                            <v-layout row="" wrap="">
                                <v-flex xs12 sm4 md3>
                                    <parainput :isPositive="true" :simge="getparabirimi()" :etiket="$t('totalamount')" :aktif="'false'"  v-model="val.TutarBilgileri.NetTutar.NetTutar" :autocomplete="'autocomplete'"></parainput>
                                </v-flex>
                                <v-flex xs12 sm4 md3>
                                    <doviztutarcomp :isPositive="true" :etiket="$t('Total-Selling-Currency')" :aktif="'false'" v-model="val.TutarBilgileri.NetTutar.NetTutarSatisDoviz" :autocomplete="'autocomplete'">
                                    </doviztutarcomp>
                                </v-flex>
                                <v-flex xs12 sm4 md3>
                                    <doviztutarcomp :isPositive="true" :etiket="$t('Total-Buying-Currency')" :aktif="'false'" v-model="val.TutarBilgileri.NetTutar.NetTutarAlisDoviz" :autocomplete="'autocomplete'">
                                    </doviztutarcomp>
                                </v-flex>

                            </v-layout>
                        </v-card-actions>
                    </v-card>
                </v-card>
            </v-flex>

            <v-flex xs12 sm12 md12 pa-1>
                <v-card class="white--text">
                    <v-card flat="">
                        <v-card-actions>

                            <v-layout row="" wrap="">
                                <v-flex xs12 sm4 md3>
                                    <v-select hide-details="" @change="kurgetir(val.TutarBilgileri.Doviz.DovizKod)" :items="doviztipi" v-model="val.TutarBilgileri.Doviz.DovizKod" clearable item-text="Title" item-value="DovizKod" :label="$t('Currency-Type-new')"></v-select>
                                </v-flex>
                                <v-flex xs12 sm4 md3>
                                    <dovizinput :isPositive="true" v-model="val.TutarBilgileri.Kur" :etiket="$t('Exchange-Amount')"> </dovizinput>
                                </v-flex>
                            </v-layout>
                        </v-card-actions>
                    </v-card>
                </v-card>
            </v-flex>

            <v-flex xs12 sm12 md12 pa-1>
                <v-card class="white--text">
                    <v-card flat="">
                        <v-card-actions>
                            <v-layout row wrap>
                                <v-flex xs12 sm4 md3>
                                    <parainput :simge="getparabirimi()" :etiket="$t('Ticket-Amount')" v-on:blur="deneme()" :isPositive="true" v-model="val.TutarBilgileri.Tutar.Tutar" :autocomplete="'autocomplete'"></parainput>
                                </v-flex>
                                <v-flex xs12 sm4 md3>
                                    <doviztutarcomp :isPositive="true" @odakkaybi="odakTutarDoviz" :etiket="$t('Currency-Selling')" v-model="val.TutarBilgileri.Tutar.TutarSatisDoviz" :autocomplete="'autocomplete'">
                                    </doviztutarcomp>
                                </v-flex>
                                <v-flex xs12 sm4 md3>
                                    <doviztutarcomp :isPositive="true" :etiket="$t('Currency-Buying')" v-model="val.TutarBilgileri.Tutar.TutarAlisDoviz" :autocomplete="'autocomplete'"></doviztutarcomp>
                                </v-flex>
                            </v-layout>
                        </v-card-actions>
                    </v-card>
                </v-card>
            </v-flex>

            <v-flex xs12 sm12 md12 pa-1>
                <v-card class="white--text">
                    <v-card flat="">
                        <v-card-actions>

                            <v-layout row wrap>
                                <v-flex xs12 sm4 md3>
                                    <parainput :isPositive="true" :simge="getparabirimi()" :etiket="'MCO/PTA'" v-model="val.TutarBilgileri.PtaTutar.PtaTutar" :autocomplete="'autocomplete'"></parainput>
                                </v-flex>
                                <v-flex xs12 sm4 md3>
                                    <doviztutarcomp :isPositive="true" @odakkaybi="odakPtaDoviz" :etiket="$t('Currency-Selling')" v-model="val.TutarBilgileri.PtaTutar.PtaSatisDoviz" :autocomplete="'autocomplete'"></doviztutarcomp>
                                </v-flex>
                                <v-flex xs12 sm4 md3>
                                    <doviztutarcomp :isPositive="true" :etiket="$t('Currency-Buying')" v-model="val.TutarBilgileri.PtaTutar.PtaAlisDoviz" :autocomplete="'autocomplete'"></doviztutarcomp>
                                </v-flex>
                            </v-layout>

                        </v-card-actions>
                    </v-card>
                </v-card>
            </v-flex>

            <v-flex xs12 sm12 md12 pa-1>
                <v-card class="white--text">
                    <v-card flat="">
                        <v-card-actions>

                            <v-layout v-if="ichatmi" wrap row>
                                <v-flex xs12 sm4 md3>
                                    <parainput :isPositive="true" :simge="getparabirimi()" :etiket="$t('Landing-Tax')" v-model="val.TutarBilgileri.AlanVergiTutar.AlanVergiTutar" :autocomplete="'autocomplete'">
                                    </parainput>
                                </v-flex>
                                <v-flex xs12 sm4 md3>
                                    <doviztutarcomp :isPositive="true" :etiket="$t('Currency-Selling')" @odakkaybi="odakAlanvergiDoviz" v-model="val.TutarBilgileri.AlanVergiTutar.AlanVergiSatisDoviz" :autocomplete="'autocomplete'">
                                    </doviztutarcomp>
                                </v-flex>
                                <v-flex xs12 sm4 md3>
                                    <doviztutarcomp :isPositive="true" :etiket="$t('Currency-Buying')" v-model="val.TutarBilgileri.AlanVergiTutar.AlanVergiAlisDoviz" :autocomplete="'autocomplete'">
                                    </doviztutarcomp>
                                </v-flex>
                            </v-layout>
                        </v-card-actions>
                    </v-card>
                </v-card>
            </v-flex>

            <v-flex v-if="dishatmi" xs12 sm12 md12 pa-1>
                <v-card class="white--text">
                    <v-card flat="">
                        <v-card-actions>

                            <v-layout row="" wrap>
                                <v-flex xs12 sm4 md3>
                                    <parainput :isPositive="true" :simge="getparabirimi()" :etiket="$t('Tax')" v-model="val.TutarBilgileri.TaxTutar.TaxTutar" :autocomplete="'autocomplete'"></parainput>
                                </v-flex>
                                <v-flex xs12 sm4 md3>
                                    <doviztutarcomp :isPositive="true" @odakkaybi="odakTaxDoviz" :etiket="$t('Currency-Selling')" v-model="val.TutarBilgileri.TaxTutar.TaxSatisDoviz" :autocomplete="'autocomplete'"></doviztutarcomp>
                                </v-flex>
                                <v-flex xs12 sm4 md3>
                                    <doviztutarcomp :isPositive="true" :etiket="$t('Currency-Buying')" v-model="val.TutarBilgileri.TaxTutar.TaxAlisDoviz" :autocomplete="'autocomplete'"></doviztutarcomp>
                                </v-flex>

                            </v-layout>
                        </v-card-actions>
                    </v-card>
                </v-card>
            </v-flex>

            <v-flex v-if="ichatmi" xs12 sm12 md12 pa-1>
                <v-card class="white--text">
                    <v-card flat="">
                        <v-card-actions>

                            <v-layout row wrap="">
                                <v-flex xs12 sm4 md3>
                                    <parainput :isPositive="true" :simge="getparabirimi()" :etiket="'Y.F.F.'" v-model="val.TutarBilgileri.YFFTutar.YFFTutar" :autocomplete="'autocomplete'"></parainput>
                                </v-flex>
                                <v-flex xs12 sm4 md3>
                                    <doviztutarcomp :isPositive="true" @odakkaybi="odakYffDoviz" :etiket="$t('Currency-Selling')" v-model="val.TutarBilgileri.YFFTutar.YFFDoviz" :autocomplete="'autocomplete'"></doviztutarcomp>
                                </v-flex>
                            </v-layout>
                        </v-card-actions>
                    </v-card>
                </v-card>
            </v-flex>

            <v-flex xs12 sm12 md12 pa-1>
                <v-card class="white--text">
                    <v-card flat="">
                        <v-card-actions>
                            <v-layout row="" wrap="">
                                <v-flex xs12 sm4 md3>
                                    <parainput :isPositive="true" :simge="getparabirimi()" :etiket="$t('Other-Service')" v-model="val.TutarBilgileri.DigerServisTutar.DigerServisTutar" :autocomplete="'autocomplete'">
                                    </parainput>
                                </v-flex>
                                <v-flex xs12 sm4 md3>
                                    <doviztutarcomp :isPositive="true" :etiket="$t('Currency-Selling')" @odakkaybi="odakDigerServisDoviz" v-model="val.TutarBilgileri.DigerServisTutar.DigerServisDoviz" :autocomplete="'autocomplete'">
                                    </doviztutarcomp>
                                </v-flex>
                            </v-layout>
                        </v-card-actions>
                    </v-card>
                </v-card>
            </v-flex>

            <v-flex xs12 sm12 md12 pa-1>
                <v-card class="white--text">
                    <v-card flat="">
                        <v-card-actions>
                            <v-layout row="" wrap="">
                                <v-flex xs12 sm4 md3>
                                    <parainput :isPositive="true" :simge="getparabirimi()" :etiket="$t('Penalty')" v-model="val.TutarBilgileri.CezaTutar.CezaTutar" :autocomplete="'autocomplete'"></parainput>
                                </v-flex>
                                <v-flex xs12 sm4 md3>
                                    <doviztutarcomp :isPositive="true" @odakkaybi="odakCezaDoviz" :etiket="$t('Currency-Selling')" v-model="val.TutarBilgileri.CezaTutar.CezaSatisTutar" :autocomplete="'autocomplete'"></doviztutarcomp>
                                </v-flex>
                                <v-flex xs12 sm4 md3>
                                    <doviztutarcomp :isPositive="true" :etiket="$t('Currency-Buying')" v-model="val.TutarBilgileri.CezaTutar.CezaAlisTutar" :autocomplete="'autocomplete'"></doviztutarcomp>
                                </v-flex>
                            </v-layout>
                        </v-card-actions>
                    </v-card>
                </v-card>
            </v-flex>

            <v-flex xs12 sm12 md12 pa-1>
                <v-card class="white--text">
                    <v-card flat="">
                        <v-card-actions>
                            <v-layout row="" wrap="">
                                <v-flex xs12 sm4 md3>
                                    <parainput :isPositive="true" :simge="getparabirimi()" :etiket="$t('Service')" v-model="val.TutarBilgileri.ServisTutar.ServisTutar" :autocomplete="'autocomplete'"></parainput>
                                </v-flex>
                                <v-flex xs12 sm4 md3>
                                    <doviztutarcomp :isPositive="true" :etiket="$t('Currency-Selling')" @odakkaybi="odakServisDoviz" v-model="val.TutarBilgileri.ServisTutar.ServisDoviz" :autocomplete="'autocomplete'"></doviztutarcomp>
                                </v-flex>
                                <v-flex xs12 sm4 md3>
                                    <v-select hide-details="" v-model="val.TanimBilgileri.ServisKod" :items="efaturatipi" clearable item-text="text" item-value="value" :label="$t('Service-Type')"></v-select>
                                </v-flex>
                            </v-layout>
                        </v-card-actions>
                    </v-card>
                </v-card>
            </v-flex>
            <v-flex xs12 sm12 md12 pa-1>
                <v-card class="white--text">
                    <v-card flat="">
                        <v-card-actions>
                            <v-layout row="" wrap="">
                                <v-flex xs12 sm4 md3>
                                    <parainput :isPositive="true" :simge="getparabirimi()" :etiket="RezTutarEtiket" v-model="val.TutarBilgileri.ReserveTutar.ReserveTutar" :autocomplete="'autocomplete'"></parainput>
                                </v-flex>
                                <v-flex xs12 sm4 md3>
                                    <doviztutarcomp :isPositive="true" :etiket="$t('Currency-Selling')" @odakkaybi="odakReserveDoviz" v-model="val.TutarBilgileri.ReserveTutar.ReserveDoviz" :autocomplete="'autocomplete'"></doviztutarcomp>
                                </v-flex>
                            </v-layout>
                        </v-card-actions>
                    </v-card>
                </v-card>
            </v-flex>
            <v-flex xs12 sm12 md12 pa-1>
                <v-card class="white--text">
                    <v-card flat="">
                        <v-card-actions>
                            <v-layout row="" wrap="">
                                <v-flex xs12 sm4 md3>
                                    <parainput :isPositive="true" :simge="getparabirimi()" :etiket="$t('Discount')" v-model="val.TutarBilgileri.IskontoTutar.IskontoTutar" :autocomplete="'autocomplete'"></parainput>
                                </v-flex>
                                <v-flex xs12 sm4 md3>
                                    <doviztutarcomp :isPositive="true" :etiket="$t('Currency-Selling')" @odakkaybi="odakIskontoDoviz" v-model="val.TutarBilgileri.IskontoTutar.IskontoDoviz" :autocomplete="'autocomplete'"></doviztutarcomp>
                                </v-flex>
                                <v-flex xs12 sm4 md3>
                                    <yuzdeinput :isPositive="true" :etiket="$t('Discount') + ' %'" v-model="val.TutarBilgileri.IskontoTutar.IskontoYuzde" :autocomplete="'autocomplete'"></yuzdeinput>
                                </v-flex>
                            </v-layout>
                        </v-card-actions>
                    </v-card>
                </v-card>
            </v-flex>

            <v-flex xs12 sm12 md12 pa-1>
                <v-card class="white--text">
                    <v-card flat="">
                        <v-card-actions>
                            <v-layout row="" wrap="">
                                <v-flex xs12 sm4 md3>
                                    <parainput :isPositive="true" :simge="getparabirimi()" :etiket="'Charter PTA'" v-model="val.TutarBilgileri.CharterTutar.CharterTutar" :autocomplete="'autocomplete'"></parainput>
                                </v-flex>
                                <v-flex xs12 sm4 md3>
                                    <doviztutarcomp :isPositive="true" :etiket="$t('Currency-Selling')" @odakkaybi="odakCharterDoviz" v-model="val.TutarBilgileri.CharterTutar.CharterSatisDoviz" :autocomplete="'autocomplete'"></doviztutarcomp>
                                </v-flex>
                                <v-flex xs12 sm4 md3>
                                    <doviztutarcomp :isPositive="true" :etiket="$t('Currency-Buying')" v-model="val.TutarBilgileri.CharterTutar.CharterAlisDoviz" :autocomplete="'autocomplete'"></doviztutarcomp>
                                </v-flex>
                            </v-layout>
                        </v-card-actions>
                    </v-card>
                </v-card>
            </v-flex>

            <v-flex xs12 sm12 md12 pa-1>
                <v-card class="white--text">
                    <v-card flat="">
                        <v-card-actions>
                            <v-layout row="" wrap="">
                                <v-flex xs12 sm4 md3>
                                    <parainput :isPositive="true" :simge="getparabirimi()" :etiket="$t('KA-Tax')" v-model="val.TutarBilgileri.KaTutar.KaTutar" :autocomplete="'autocomplete'"></parainput>
                                </v-flex>
                                <v-flex xs12 sm4 md3>
                                    <doviztutarcomp :isPositive="true" :etiket="$t('Currency-Selling')" @odakkaybi="odakKaDoviz" v-model="val.TutarBilgileri.KaTutar.KaDoviz" :autocomplete="'autocomplete'"></doviztutarcomp>
                                </v-flex>
                            </v-layout>
                        </v-card-actions>
                    </v-card>
                </v-card>
            </v-flex>

            <v-flex xs12 sm12 md12 pa-1>
                <v-card class="white--text">
                    <v-card flat="">
                        <v-card-actions>
                            <v-layout row="" wrap="">
                                <v-flex xs12 sm4 md3>
                                    <parainput :isPositive="true" :simge="getparabirimi()" etiket="GROSS" v-model="val.DigerBilgileri.GrossTutar" :autocomplete="'autocomplete'">
                                    </parainput>
                                </v-flex>
                            </v-layout>
                        </v-card-actions>
                    </v-card>
                </v-card>
            </v-flex>

            <v-flex xs12 sm12 md12 pa-1>
                <v-card class="white--text">
                    <v-card flat="">
                        <v-card-actions>
                            <v-layout row="" wrap="">
                                <v-flex xs12 sm4 md3>
                                    <parainput :isPositive="true" :simge="getparabirimi()" :etiket="$t('Purchase-Service')" v-model="val.OdemeBilgileri.AlisServisTutar.AlisServisTutar" :autocomplete="'autocomplete'">
                                    </parainput>
                                </v-flex>
                                <v-flex xs12 sm4 md3>
                                    <doviztutarcomp :isPositive="true" :etiket="$t('Currency-Buying')" @odakkaybi="odakAlisServisDoviz" v-model="val.OdemeBilgileri.AlisServisTutar.AlisServisDoviz" :autocomplete="'autocomplete'"></doviztutarcomp>
                                </v-flex>

                            </v-layout>
                        </v-card-actions>
                    </v-card>
                </v-card>
            </v-flex>

            <v-flex xs12 sm12 md12 pa-1>
                <v-card class="white--text">
                    <v-card flat="">
                        <v-card-actions>
                            <v-layout row="" wrap="">

                                <v-flex xs12 sm3 md3>
                                    <parainput :isPositive="true" :simge="getparabirimi()" :etiket="$t('Commission')" v-model="parainputdeger" :autocomplete="'autocomplete'"></parainput>
                                </v-flex>
                                <v-flex xs12 sm3 md3>
                                    <doviztutarcomp :isPositive="true" :etiket="$t('Currency-Selling')" v-model="parainputdeger" :autocomplete="'autocomplete'">
                                    </doviztutarcomp>
                                </v-flex>
                                <v-flex xs12 sm3 md3>
                                    <doviztutarcomp :isPositive="true" :etiket="$t('Currency-Buying')" v-model="parainputdeger" :autocomplete="'autocomplete'">
                                    </doviztutarcomp>
                                </v-flex>
                                <v-flex xs12 sm3 md3>
                                    <v-select hide-details="" :items="komisyontip" v-model="val.OdemeBilgileri.KomisyonTip" clearable item-text="text" item-value="value" :label="$t('Commission-Type')"></v-select>
                                </v-flex>
                            </v-layout>
                        </v-card-actions>
                    </v-card>
                </v-card>
            </v-flex>

            <v-flex xs12 sm12 md12 pa-1>
                <v-card class="white--text">
                    <v-card flat="">
                        <v-card-actions>
                            <v-layout row="" wrap="">
                                <v-flex xs12 sm4 md3>
                                    <parainput :isPositive="true" :simge="getparabirimi()" :etiket="$t('Analysis')+'1'" v-model="val.TanimBilgileri.AnalizTutar" :autocomplete="'autocomplete'"></parainput>
                                </v-flex>
                                <v-flex xs12 sm4 md3>
                                    <analizcomp :etiket="$t('Analysis-Code')" v-model="val.TanimBilgileri.AnalizKod.AnalizKod"></analizcomp>

                                </v-flex>
                            </v-layout>
                        </v-card-actions>
                    </v-card>
                </v-card>
            </v-flex>

            <v-flex xs12 sm12 md12 pa-1>
                <v-card class="white--text">
                    <v-card flat="">
                        <v-card-actions>
                            <v-layout row="" wrap="">
                                <v-flex xs12 sm4 md3>
                                    <parainput :isPositive="true" :simge="getparabirimi()" :etiket=" $t('Analysis') + '2'" v-model="val.TanimBilgileri.AnalizTutar1" :autocomplete="'autocomplete'"></parainput>
                                </v-flex>
                                <v-flex xs12 sm4 md3>
                                    <analizcomp :etiket="$t('Analysis-Code') +'2'" v-model="val.TanimBilgileri.AnalizKod1.AnalizKod"></analizcomp>
                                </v-flex>
                            </v-layout>
                        </v-card-actions>
                    </v-card>
                </v-card>
            </v-flex>

        </v-layout>

    </v-form>
</div>
</template>

<script>
import auth from '../../../../api/auth'
import tarihcomp from '../../customcomp/tarihcomp'
import parainput from '@/components/app/customcomp/parainput.vue'
import dovizinput from '@/components/app/customcomp/dovizinput.vue'
import yuzdeinput from '@/components/app/customcomp/yuzdeinput.vue'
import doviztutarcomp from '@/components/app/customcomp/doviztutarcomp.vue'
import analizcomp from "@/components/app/bilet/partpage/analizcomp.vue"
import helpers from "@/components/app/customcomp/helpers.js"

export default {
    props: ["value", "ichatmi", "dishatmi"],
    beforeMount: beforeMount,
    components: {
        tarihcomp,
        parainput,
        dovizinput,
        yuzdeinput,
        doviztutarcomp,
        analizcomp
    },

    computed: {
        val: {
            get: function () {
                return this.value;

            },
            set: function (newValue) {
                this.$emit('input', newValue)
            },
        },
    },

    data() {
        return {
            RezTutarEtiket: 'Reserve Tutar',
            doviztipi: [],
            kurdegeri: 0,
            kur: null,
            efaturatipi: '',
            parainputdeger: 0,
            komisyontip: [{
                text: this.$t('K-Commission'),
                value: 'K'
            }, {
                text: this.$t('N-No-commission'),
                value: 'N'
            }],
           
            efaturatipi: [{
                    text: this.$t('Commercial'),
                    value: '0'
                },
                {
                    text: this.$t('Basic'),
                    value: '1'
                },
                {
                    text: this.$t('Export'),
                    value: '2'
                }
            ],
        }
    },

    mounted() {
        this.kurtutarlariyaz();
    },

    watch: {
        'val.TutarBilgileri.Kur': function (value1) {
            if (value1 != 0) {
                this.val.TutarBilgileri.Tutar.TutarSatisDoviz = this.val.TutarBilgileri.Tutar.Tutar / value1
                this.val.TutarBilgileri.PtaTutar.PtaSatisDoviz = this.val.TutarBilgileri.PtaTutar.PtaTutar / value1

                if (this.ichatmi == true) {
                    this.val.TutarBilgileri.YFFTutar.YFFDoviz = this.val.TutarBilgileri.YFFTutar.YFFTutar / value1
                    this.val.TutarBilgileri.AlanVergiTutar.AlanVergiSatisDoviz = this.val.TutarBilgileri.AlanVergiTutar
                        .AlanVergiTutar /
                        value1
                }

                if (this.dishatmi == true) {
                    this.val.TutarBilgileri.TaxTutar.TaxSatisDoviz = this.val.TutarBilgileri.TaxTutar.TaxTutar / value1
                }

                this.val.TutarBilgileri.DigerServisTutar.DigerServisDoviz = this.val.TutarBilgileri.DigerServisTutar
                    .DigerServisTutar /
                    value1
                this.val.TutarBilgileri.CezaTutar.CezaSatisTutar = this.val.TutarBilgileri.CezaTutar.CezaTutar / value1
                this.val.TutarBilgileri.ServisTutar.ServisDoviz = this.val.TutarBilgileri.ServisTutar.ServisTutar /
                    value1
                this.val.TutarBilgileri.ReserveTutar.ReserveDoviz = this.val.TutarBilgileri.ReserveTutar.ReserveTutar /
                    value1
                this.val.TutarBilgileri.IskontoTutar.IskontoDoviz = this.val.TutarBilgileri.IskontoTutar.IskontoTutar /
                    value1
                this.val.TutarBilgileri.CharterTutar.CharterSatisDoviz = this.val.TutarBilgileri.CharterTutar.CharterTutar /
                    value1
                this.val.TutarBilgileri.KaTutar.KaDoviz = this.val.TutarBilgileri.KaTutar.KaTutar / value1
                this.val.OdemeBilgileri.AlisServisTutar.AlisServisDoviz = this.val.OdemeBilgileri.AlisServisTutar
                    .AlisServisTutar /
                    value1
            } else {
                value1 = 0
                this.val.TutarBilgileri.Tutar.TutarSatisDoviz = 0
                this.val.TutarBilgileri.PtaTutar.PtaSatisDoviz = 0

                if (this.ichatmi == true) {
                    this.val.TutarBilgileri.YFFTutar.YFFDoviz = 0
                    this.val.TutarBilgileri.AlanVergiTutar.AlanVergiSatisDoviz = 0
                }

                if (this.dishatmi == true) {
                    this.val.TutarBilgileri.TaxTutar.TaxSatisDoviz = 0
                }

                this.val.TutarBilgileri.DigerServisTutar.DigerServisDoviz = 0
                this.val.TutarBilgileri.CezaTutar.CezaSatisTutar = 0
                this.val.TutarBilgileri.ServisTutar.ServisDoviz = 0
                this.val.TutarBilgileri.ReserveTutar.ReserveDoviz = 0
                this.val.TutarBilgileri.IskontoTutar.IskontoDoviz = 0
                this.val.TutarBilgileri.CharterTutar.CharterSatisDoviz = 0
                this.val.TutarBilgileri.KaTutar.KaDoviz = 0
                this.val.OdemeBilgileri.AlisServisTutar.AlisServisDoviz = 0
            }
        },

        'val.TutarBilgileri.Tutar.Tutar': function (tutar) {
            this.doviztutarcevir('val.TutarBilgileri.Tutar.Tutar');
        },
        'val.TutarBilgileri.Tutar.TutarSatisDoviz': function (tutar) {
            //  this.doviztutarcevir('val.TutarBilgileri.Tutar.TutarSatisDoviz');
        },
        'val.TutarBilgileri.PtaTutar.PtaTutar': function (tutar) {
            this.doviztutarcevir('val.TutarBilgileri.PtaTutar.PtaTutar');
        },
        'val.TutarBilgileri.PtaTutar.PtaSatisDoviz': function (tutar) {
            //   this.doviztutarcevir('val.TutarBilgileri.PtaTutar.PtaSatisDoviz');
        },
        'val.TutarBilgileri.AlanVergiTutar.AlanVergiTutar': function (tutar) {
            this.doviztutarcevir('val.TutarBilgileri.AlanVergiTutar.AlanVergiTutar');
        },
        'val.TutarBilgileri.AlanVergiTutar.AlanVergiSatisDoviz': function (tutar) {
            //  this.doviztutarcevir('val.TutarBilgileri.AlanVergiTutar.AlanVergiSatisDoviz');
        },
        'val.TutarBilgileri.TaxTutar.TaxTutar': function (tutar) {
            this.doviztutarcevir('val.TutarBilgileri.TaxTutar.TaxTutar');
        },
        'val.TutarBilgileri.TaxTutar.TaxSatisDoviz': function (tutar) {
            //  this.doviztutarcevir('val.TutarBilgileri.TaxTutar.TaxSatisDoviz');
        },
        'val.TutarBilgileri.YFFTutar.YFFTutar': function (tutar) {
            this.doviztutarcevir('val.TutarBilgileri.YFFTutar.YFFTutar');
        },
        'val.TutarBilgileri.YFFTutar.YFFDoviz': function (tutar) {
            //  this.doviztutarcevir('val.TutarBilgileri.YFFTutar.YFFDoviz');
        },
        'val.TutarBilgileri.DigerServisTutar.DigerServisTutar': function (tutar) {
            this.doviztutarcevir('val.TutarBilgileri.DigerServisTutar.DigerServisTutar');
        },
        'val.TutarBilgileri.DigerServisTutar.DigerServisDoviz': function (tutar) {
            //  this.doviztutarcevir('val.TutarBilgileri.DigerServisTutar.DigerServisDoviz');
        },
        'val.TutarBilgileri.CezaTutar.CezaTutar': function (tutar) {
            this.doviztutarcevir('val.TutarBilgileri.CezaTutar.CezaTutar');
        },
        'val.TutarBilgileri.CezaTutar.CezaSatisTutar': function (tutar) {
            //  this.doviztutarcevir('val.TutarBilgileri.CezaTutar.CezaSatisTutar');
        },
        'val.TutarBilgileri.ServisTutar.ServisTutar': function (tutar) {
            this.doviztutarcevir('val.TutarBilgileri.ServisTutar.ServisTutar');
        },
        'val.TutarBilgileri.ServisTutar.ServisDoviz': function (tutar) {
            //  this.doviztutarcevir('val.TutarBilgileri.ServisTutar.ServisDoviz');
        },
        'val.TutarBilgileri.ReserveTutar.ReserveTutar': function (tutar) {
            this.doviztutarcevir('val.TutarBilgileri.ReserveTutar.ReserveTutar');
        },
        'val.TutarBilgileri.ReserveTutar.ReserveDoviz': function (tutar) {
            // this.doviztutarcevir('val.TutarBilgileri.ReserveTutar.ReserveDoviz');
        },
        'val.TutarBilgileri.IskontoTutar.IskontoTutar': function (tutar) {
            this.doviztutarcevir('val.TutarBilgileri.IskontoTutar.IskontoTutar');
        },
        'val.TutarBilgileri.IskontoTutar.IskontoDoviz': function (tutar) {
            //  this.doviztutarcevir('val.TutarBilgileri.IskontoTutar.IskontoDoviz');
        },
        'val.TutarBilgileri.CharterTutar.CharterTutar': function (tutar) {
            this.doviztutarcevir('val.TutarBilgileri.CharterTutar.CharterTutar');
        },
        'val.TutarBilgileri.CharterTutar.CharterSatisDoviz': function (tutar) {
            //  this.doviztutarcevir('val.TutarBilgileri.CharterTutar.CharterSatisDoviz');
        },
        'val.TutarBilgileri.KaTutar.KaTutar': function (tutar) {
            this.doviztutarcevir('val.TutarBilgileri.KaTutar.KaTutar');
        },
        'val.TutarBilgileri.KaTutar.KaDoviz': function (tutar) {
            //  this.doviztutarcevir('val.TutarBilgileri.KaTutar.KaDoviz');
        },
        'val.OdemeBilgileri.AlisServisTutar.AlisServisTutar': function (tutar) {
            this.doviztutarcevir('val.OdemeBilgileri.AlisServisTutar.AlisServisTutar');
        },
        'val.OdemeBilgileri.AlisServisTutar.AlisServisDoviz': function (tutar) {
            //  this.doviztutarcevir('val.OdemeBilgileri.AlisServisTutar.AlisServisDoviz');
        }

    },
    methods: {

        odakTutarDoviz(v) {
            this.val.TutarBilgileri.Tutar.Tutar = this.val.TutarBilgileri.Kur * v
        },
        odakPtaDoviz(v) {
            this.val.TutarBilgileri.PtaTutar.PtaTutar = this.val.TutarBilgileri.Kur * v
        },
        odakAlanvergiDoviz(v) {
            this.val.TutarBilgileri.AlanVergiTutar.AlanVergiTutar = this.val.TutarBilgileri.Kur * v
        },
        odakTaxDoviz(v) {
            this.val.TutarBilgileri.TaxTutar.TaxTutar = this.val.TutarBilgileri.Kur * v
        },
        odakYffDoviz(v) {
            this.val.TutarBilgileri.YFFTutar.YFFTutar = this.val.TutarBilgileri.Kur * v
        },
        odakDigerServisDoviz(v) {
            this.val.TutarBilgileri.DigerServisTutar.DigerServisTutar = this.val.TutarBilgileri.Kur * v
        },
        odakCezaDoviz(v) {
            this.val.TutarBilgileri.CezaTutar.CezaTutar = this.val.TutarBilgileri.Kur * v
        },

        odakServisDoviz(v) {
            this.val.TutarBilgileri.ServisTutar.ServisTutar = this.val.TutarBilgileri.Kur * v
        },

        odakReserveDoviz(v) {
            this.val.TutarBilgileri.ReserveTutar.ReserveTutar = this.val.TutarBilgileri.Kur * v
        },

        odakIskontoDoviz(v) {
            this.val.TutarBilgileri.IskontoTutar.IskontoTutar = this.val.TutarBilgileri.Kur * v
        },
        odakCharterDoviz(v) {
            this.val.TutarBilgileri.CharterTutar.CharterTutar = this.val.TutarBilgileri.Kur * v
        },

        odakKaDoviz(v) {
            this.val.TutarBilgileri.KaTutar.KaTutar = this.val.TutarBilgileri.Kur * v
        },

        odakAlisServisDoviz(v) {
            this.val.OdemeBilgileri.AlisServisTutar.AlisServisTutar = this.val.TutarBilgileri.Kur * v
        },

        kurtutarlariyaz() {

            if (this.val.TutarBilgileri.Kur != 0) {
                this.val.TutarBilgileri.Tutar.TutarSatisDoviz = this.val.TutarBilgileri.Tutar.Tutar / this.val.TutarBilgileri
                    .Kur
                this.val.TutarBilgileri.PtaTutar.PtaSatisDoviz = this.val.TutarBilgileri.PtaTutar.PtaTutar / this.val
                    .TutarBilgileri.Kur

                if (this.ichatmi == true) {
                    this.val.TutarBilgileri.YFFTutar.YFFDoviz = this.val.TutarBilgileri.YFFTutar.YFFTutar / this.val
                        .TutarBilgileri.Kur
                    this.val.TutarBilgileri.AlanVergiTutar.AlanVergiSatisDoviz = this.val.TutarBilgileri.AlanVergiTutar
                        .AlanVergiTutar /
                        this.val.TutarBilgileri.Kur
                }

                if (this.dishatmi == true) {
                    this.val.TutarBilgileri.TaxTutar.TaxSatisDoviz = this.val.TutarBilgileri.TaxTutar.TaxTutar / this.val
                        .TutarBilgileri.Kur
                }

                this.val.TutarBilgileri.DigerServisTutar.DigerServisDoviz = this.val.TutarBilgileri.DigerServisTutar
                    .DigerServisTutar /
                    this.val.TutarBilgileri.Kur
                this.val.TutarBilgileri.CezaTutar.CezaSatisTutar = this.val.TutarBilgileri.CezaTutar.CezaTutar / this.val
                    .TutarBilgileri.Kur
                this.val.TutarBilgileri.ServisTutar.ServisDoviz = this.val.TutarBilgileri.ServisTutar.ServisTutar /
                    this.val.TutarBilgileri.Kur
                this.val.TutarBilgileri.ReserveTutar.ReserveDoviz = this.val.TutarBilgileri.ReserveTutar.ReserveTutar /
                    this.val.TutarBilgileri.Kur
                this.val.TutarBilgileri.IskontoTutar.IskontoDoviz = this.val.TutarBilgileri.IskontoTutar.IskontoTutar /
                    this.val.TutarBilgileri.Kur
                this.val.TutarBilgileri.CharterTutar.CharterSatisDoviz = this.val.TutarBilgileri.CharterTutar.CharterTutar /
                    this.val.TutarBilgileri.Kur
                this.val.TutarBilgileri.KaTutar.KaDoviz = this.val.TutarBilgileri.KaTutar.KaTutar / this.val.TutarBilgileri
                    .Kur
                this.val.OdemeBilgileri.AlisServisTutar.AlisServisDoviz = this.val.OdemeBilgileri.AlisServisTutar
                    .AlisServisTutar /
                    this.val.TutarBilgileri.Kur
            } else {
                this.val.TutarBilgileri.Kur = 0
                this.val.TutarBilgileri.Tutar.TutarSatisDoviz = 0
                this.val.TutarBilgileri.PtaTutar.PtaSatisDoviz = 0

                if (this.ichatmi == true) {
                    this.val.TutarBilgileri.YFFTutar.YFFDoviz = 0
                    this.val.TutarBilgileri.AlanVergiTutar.AlanVergiSatisDoviz = 0
                }

                if (this.dishatmi == true) {
                    this.val.TutarBilgileri.TaxTutar.TaxSatisDoviz = 0
                }

                this.val.TutarBilgileri.DigerServisTutar.DigerServisDoviz = 0
                this.val.TutarBilgileri.CezaTutar.CezaSatisTutar = 0
                this.val.TutarBilgileri.ServisTutar.ServisDoviz = 0
                this.val.TutarBilgileri.ReserveTutar.ReserveDoviz = 0
                this.val.TutarBilgileri.IskontoTutar.IskontoDoviz = 0
                this.val.TutarBilgileri.CharterTutar.CharterSatisDoviz = 0
                this.val.TutarBilgileri.KaTutar.KaDoviz = 0
                this.val.OdemeBilgileri.AlisServisTutar.AlisServisDoviz = 0

            }
        },

        roundNumber(num, scale) {
            if (!("" + num).includes("e")) {
                return +(Math.round(num + "e+" + scale) + "e-" + scale);
            } else {
                var arr = ("" + num).split("e");
                var sig = ""
                if (+arr[1] + scale > 0) {
                    sig = "+";
                }
                return +(Math.round(+arr[0] + "e" + sig + (+arr[1] + scale)) + "e-" + scale);
            }
        },
        doviztutarcevir(nesne) {

            var kur = 1

            if (this.val.TutarBilgileri.Kur == 0 || this.val.TutarBilgileri.Kur == null) {
                kur = 1
            } else {
                kur = this.val.TutarBilgileri.Kur
            }

            if (nesne == 'val.TutarBilgileri.Tutar.Tutar') {
                this.val.TutarBilgileri.Tutar.TutarSatisDoviz = this.val.TutarBilgileri.Tutar.Tutar / kur
            } else if (nesne == 'val.TutarBilgileri.Tutar.TutarSatisDoviz') {
                this.val.TutarBilgileri.Tutar.Tutar = this.val.TutarBilgileri.Tutar.TutarSatisDoviz * kur
            } else if (nesne == 'val.TutarBilgileri.PtaTutar.PtaTutar') {
                this.val.TutarBilgileri.PtaTutar.PtaSatisDoviz = this.val.TutarBilgileri.PtaTutar.PtaTutar / kur
            } else if (nesne == 'val.TutarBilgileri.PtaTutar.PtaSatisDoviz') {
                this.val.TutarBilgileri.PtaTutar.PtaTutar = this.val.TutarBilgileri.PtaTutar.PtaSatisDoviz * kur
            } else if (nesne == 'val.TutarBilgileri.AlanVergiTutar.AlanVergiTutar') {
                this.val.TutarBilgileri.AlanVergiTutar.AlanVergiSatisDoviz = this.val.TutarBilgileri.AlanVergiTutar
                    .AlanVergiTutar / kur
            } else if (nesne == 'val.TutarBilgileri.AlanVergiTutar.AlanVergiSatisDoviz') {
                this.val.TutarBilgileri.AlanVergiTutar.AlanVergiTutar = this.val.TutarBilgileri.AlanVergiTutar
                    .AlanVergiSatisDoviz * kur
            } else if (nesne == 'val.TutarBilgileri.TaxTutar.TaxTutar') {
                this.val.TutarBilgileri.TaxTutar.TaxSatisDoviz = this.val.TutarBilgileri.TaxTutar.TaxTutar / kur
            } else if (nesne == 'val.TutarBilgileri.TaxTutar.TaxSatisDoviz') {
                this.val.TutarBilgileri.TaxTutar.TaxTutar = this.val.TutarBilgileri.TaxTutar.TaxSatisDoviz * kur
            } else if (nesne == 'val.TutarBilgileri.YFFTutar.YFFTutar') {
                this.val.TutarBilgileri.YFFTutar.YFFDoviz = this.val.TutarBilgileri.YFFTutar.YFFTutar / kur
            } else if (nesne == 'val.TutarBilgileri.YFFTutar.YFFDoviz') {
                this.val.TutarBilgileri.YFFTutar.YFFTutar = this.val.TutarBilgileri.YFFTutar.YFFDoviz * kur
            } else if (nesne == 'val.TutarBilgileri.DigerServisTutar.DigerServisTutar') {
                this.val.TutarBilgileri.DigerServisTutar.DigerServisDoviz = this.val.TutarBilgileri.DigerServisTutar
                    .DigerServisTutar / kur
            } else if (nesne == 'val.TutarBilgileri.DigerServisTutar.DigerServisDoviz') {
                this.val.TutarBilgileri.DigerServisTutar.DigerServisTutar = this.val.TutarBilgileri.DigerServisTutar
                    .DigerServisDoviz * kur
            } else if (nesne == 'val.TutarBilgileri.CezaTutar.CezaTutar') {
                this.val.TutarBilgileri.CezaTutar.CezaSatisTutar = this.val.TutarBilgileri.CezaTutar.CezaTutar / kur
            } else if (nesne == 'val.TutarBilgileri.CezaTutar.CezaSatisTutar') {
                this.val.TutarBilgileri.CezaTutar.CezaTutar = this.val.TutarBilgileri.CezaTutar.CezaSatisTutar * kur
            } else if (nesne == 'val.TutarBilgileri.ServisTutar.ServisTutar') {
                this.val.TutarBilgileri.ServisTutar.ServisDoviz = this.val.TutarBilgileri.ServisTutar.ServisTutar / kur
            } else if (nesne == 'val.TutarBilgileri.ServisTutar.ServisDoviz') {
                this.val.TutarBilgileri.ServisTutar.ServisTutar = this.val.TutarBilgileri.ServisTutar.ServisDoviz * kur
            } else if (nesne == 'val.TutarBilgileri.ReserveTutar.ReserveTutar') {
                this.val.TutarBilgileri.ReserveTutar.ReserveDoviz = this.val.TutarBilgileri.ReserveTutar.ReserveTutar / kur
            } else if (nesne == 'val.TutarBilgileri.ReserveTutar.ReserveDoviz') {
                this.val.TutarBilgileri.ReserveTutar.ReserveTutar = this.val.TutarBilgileri.ReserveTutar.ReserveDoviz * kur
            } else if (nesne == 'val.TutarBilgileri.IskontoTutar.IskontoTutar') {
                this.val.TutarBilgileri.IskontoTutar.IskontoDoviz = this.val.TutarBilgileri.IskontoTutar.IskontoTutar / kur
            } else if (nesne == 'val.TutarBilgileri.IskontoTutar.IskontoDoviz') {
                this.val.TutarBilgileri.IskontoTutar.IskontoTutar = this.val.TutarBilgileri.IskontoTutar.IskontoDoviz * kur
            } else if (nesne == 'val.TutarBilgileri.CharterTutar.CharterTutar') {
                this.val.TutarBilgileri.CharterTutar.CharterSatisDoviz = this.val.TutarBilgileri.CharterTutar.CharterTutar /
                    kur
            } else if (nesne == 'val.TutarBilgileri.CharterTutar.CharterSatisDoviz') {
                this.val.TutarBilgileri.CharterTutar.CharterTutar = this.val.TutarBilgileri.CharterTutar.CharterSatisDoviz *
                    kur
            } else if (nesne == 'val.TutarBilgileri.KaTutar.KaTutar') {
                this.val.TutarBilgileri.KaTutar.KaDoviz = this.val.TutarBilgileri.KaTutar.KaTutar / kur
            } else if (nesne == 'val.TutarBilgileri.KaTutar.KaDoviz') {
                this.val.TutarBilgileri.KaTutar.KaTutar = this.val.TutarBilgileri.KaTutar.KaDoviz * kur
            } else if (nesne == 'val.OdemeBilgileri.AlisServisTutar.AlisServisTutar') {
                this.val.OdemeBilgileri.AlisServisTutar.AlisServisDoviz = this.val.OdemeBilgileri.AlisServisTutar
                    .AlisServisTutar / kur
            } else if (nesne == 'val.OdemeBilgileri.AlisServisTutar.AlisServisDoviz') {
                this.val.OdemeBilgileri.AlisServisTutar.AlisServisTutar = this.val.OdemeBilgileri.AlisServisTutar
                    .AlisServisDoviz * kur
            }

        },

        getparabirimi() {
            return helpers.getparabirimi()
        },
        getDateNow: getDateNow,
        kurgetir(kod) {
            var params1 = {
                Tarih: this.val.TarihBilgileri.SatisTarihi,
                DovizKod: kod
            }

            this.$http.post(auth.API_URL + 'api/Definitions/GetWebRate', params1, {
                headers: auth.getAuthCompaniesInfo()
            }).then((response) => {
                      if(response.body == 0.0){
                  this.val.TutarBilgileri.Kur = 1
                    }else{
                this.val.TutarBilgileri.Kur = response.body
                    }
            }, (response) => {
                if (response.status === 0) {
                    this.text1 = 'Service Unavailable-Kur Hesapla'
                    this.snackbar = true
                } else {
                    this.text1 = 'Service Unavailable-Kur Hesapla'
                    this.snackbar = true
                }
            })
        },
    },
}

function getDateNow() {

    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1; //January is 0!
    var yyyy = today.getFullYear();

    if (dd < 10) {
        dd = '0' + dd
    }

    if (mm < 10) {
        mm = '0' + mm
    }

    today = yyyy + '-' + mm + '-' + dd + 'T00:00:00'
    return today
}

function beforeMount() {
    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var params1 = {
        CompanyCode: credentials.SirketKodu
    }

    this.$http.post(auth.API_URL + 'api/currency/List', params1, {
        headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
    }).then((response) => {
        this.doviztipi = response.body
    }, (response) => {
        if (response.status === 0) {
            this.text1 = 'Service Unavailable-Döviz'
            this.snackbar = true
        } else {
            this.text1 = 'Service Unavailable-Döviz'
            this.snackbar = true
        }
    })

    this.$http.post(auth.API_URL + 'api/TicketHelpers/GetReserveName', params1, {
        headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
    }).then((response) => {
        if (response.body.length > 0) {
            this.RezTutarEtiket = response.body
        }
    }, (response) => {
        if (response.status === 0) {
            this.text1 = 'Service Unavailable-class'
            this.progress = false
            this.snackbar = true
        } else {
            this.text1 = 'Service Unavailable-class'
            this.progress = false
            this.snackbar = true
        }
    })

}
</script>
